module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "miniTV3.f64a8aaf.jpg" + "?" + Date.now();